import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'email_type',
})
export class EmailTypeFilterPipe implements PipeTransform {
    transform(type: number) {
        if (type == 1) {
            return 'Email'
        } else if (type == 2) {
            return 'Document Request'
        } else if (type == 3) {
            return 'Signature Request'
        }
        else if (type == 4) {
            return 'Approval Request'
        }
        else if (type == 5) {
            return 'Survey Request'
        }
        else if (type == 6) {
            return 'Payment Request'
        }
        return type
    }
}
